import { Component, OnInit } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { GeneralService } from '../../../services/general/general.service';
import { Categoria } from '../../../../model/class/Categoria';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { finalize } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';

const VISIBLE_NAME = 'HOME';

@Component({
  selector: 'app-especiales-portada',
  templateUrl: './especiales-portada.component.html',
  styleUrls: ['./especiales-portada.component.css'],
  providers: [DragulaService]
})
export class EspecialesPortadaComponent implements OnInit {

  loaders = {
    form: false
  };
  page = 1;

  enPortadaParams: any;
  todosEspecialesParams: any;

  enPortada: Categoria[] = [];
  todosEspeciales: Categoria[] = [];

  constructor(
    private _generalService: GeneralService,
    private dragulaService: DragulaService,
    private categoriaService: CategoriaService,
    private toasts: ToastsManager
  ) {

    dragulaService.setOptions('bag-categories', {
    });

    dragulaService.dropModel.subscribe((value) => {
      this.emparejarOrden();
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });

    this.enPortadaParams = {'visibility': [VISIBLE_NAME]};
    this.todosEspecialesParams = {'notVisibility': [VISIBLE_NAME]};
  }

  private onDropModel(args) {
    let [el, target, source] = args;
    // do something else
  }

  private onRemoveModel(args) {
    let [el, source] = args;
    // do something else
  }

  ngOnInit() {
    this.categoriaService.getDeFantasia(this.enPortadaParams)
      .subscribe( data => {
        _.each(data, (o) => {
          this.enPortada.push(new Categoria(o));
        });
        this.emparejarOrden();
      });

    this.categoriaService.getDeFantasia(this.todosEspecialesParams)
      .subscribe( data => {
        _.each(data, (o) => {
          this.todosEspeciales.push(new Categoria(o));
        });
      });
  }

  emparejarOrden() {

    _.each(this.enPortada, (cat: Categoria, index) => {
      cat.orden = index + 1;

      if (index > 5) {
        this.todosEspeciales.push(_.clone(cat));
      } else {
        if (cat.visibleEn.indexOf(VISIBLE_NAME) === -1) {
          cat.visibleEn.push(VISIBLE_NAME);
        }
      }
    });

    if (this.enPortada.length >= 6) {
      this.enPortada.splice(6, this.enPortada.length - 1);
    }

    _.each(this.todosEspeciales, (cat: Categoria) => {
      const indice = cat.visibleEn.indexOf(VISIBLE_NAME);
      if (indice >= 0) {
       cat.visibleEn.splice(indice, 1);
       cat.modificado = true;
      }
    });
  }

  guardarCambios() {

    this.loaders.form = true;

    const obsModificar = [];
    const especialesModificados = _.filter(this.todosEspeciales, {'modificado': true});

    _.each(this.enPortada, (o: Categoria) => {
      obsModificar.push(this.categoriaService.edit(o.id, o.getFormDataVisibleEn()));
    });
    _.each(especialesModificados, (o: Categoria) => {
      obsModificar.push(this.categoriaService.edit(o.id, o.getFormDataVisibleEn()));
    });

    forkJoin(obsModificar)
      .pipe(
        finalize(() => {
          this.loaders.form = false;
        }
      ))
      .subscribe(
        (res) => {
          this.toasts.success('Cambios guardados.');
          this._generalService.revalidarCache('selection').subscribe();

        }, (error) => {
          this.toasts.error('Ah ocurrido un error al realizar los cambios.', 'Ups...');
          console.error(error);
        }
      );

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/especiales-portada/especiales-portada.component.ts